// heavily inspired by:
// https://stackoverflow.com/questions/5736398/how-to-calculate-the-svg-path-for-an-arc-of-a-circle

function polarToCartesian(
  centerPoint: number,
  radius: number,
  angleInDegrees: number,
): {
  x: number;
  y: number;
} {
  const angleInRadians = ((angleInDegrees - 90) * Math.PI) / 180;

  return {
    x: centerPoint + radius * Math.cos(angleInRadians),
    y: centerPoint + radius * Math.sin(angleInRadians),
  };
}

export function describeArcPath(
  diameterInPx: number,
  strokeWidthInPx: number,
  angleInDegrees: number,
): string {
  const centerPoint = diameterInPx / 2;
  const radius = centerPoint - strokeWidthInPx / 2;
  const startAt = polarToCartesian(centerPoint, radius, angleInDegrees);
  const endAt = polarToCartesian(centerPoint, radius, 0);

  const largeArcFlag = angleInDegrees <= 180 ? "0" : "1";

  const d = [
    "M",
    startAt.x,
    startAt.y,
    "A",
    radius,
    radius,
    0,
    largeArcFlag,
    0,
    endAt.x,
    endAt.y,
  ].join(" ");

  return d;
}
